import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import "./ResponsiveHero.css";

import HeroImg from "../../../assets/Illustration.svg";
import search from "../../../assets/search.svg";

export const Hero = () => {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/recipes?q=${encodeURIComponent(query.trim())}`);
    } else {
      navigate("/recipes");
    }
  };

  return (
    <section className="HeroSec">
      {/* Dead right absolute background illustration behind navbar */}
      <img src={HeroImg} alt="Hero illustration" className="hero-bg-img" />

      <div className="contentWrapper">
        <div className="leftContent">
          <h2>Ready for Trying a new recipe?</h2>
          <form className="handle" onSubmit={handleSearch}>
            <input
              type="text"
              placeholder="Search healthy recipes"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <button type="submit">
              <img src={search} alt="search" style={{ width: "1rem" }} />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};
